import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../app/store';

type SubscriptionPayload = {
    deviceLimit: number | boolean | null;
    endDate: number | null;
    planId: string;
    planName: string;
    deviceCount: number;
    startDate: number;
    neverExpires: boolean;
    description: string;
    activationId: string;
    featurePackageId: string;
    featurePackageName: string;
    reveneraSupported?: boolean;
    id?: string;
    deviceLicenseId?: string;
    subscriptionNotes?: string;
    [key: string]: unknown;
};

type SubscriptionState = {
    planFeatures: unknown[];
    subscriptionPayload: SubscriptionPayload;
    reveneraId: string;
};

const subscriptionSlice = createSlice({
    name: 'subscription',
    initialState: {
        planFeatures: [],
        subscriptionPayload: {
            deviceLimit: null as number | null,
            endDate: null as number | null,
            planId: '',
            planName: '',
            deviceCount: 0,
            startDate: new Date().getTime(),
            neverExpires: false,
            description: '',
            activationId: '',
            featurePackageId: '',
            featurePackageName: '',
        },
        reveneraId: '',
    } as SubscriptionState,
    reducers: {
        setSubscriptionPayload: (state, action: PayloadAction<any>) => {
            state.subscriptionPayload = action.payload;
        },
        mergeSubscriptionPayload: (state, action: PayloadAction<Partial<SubscriptionPayload>>) => {
            state.subscriptionPayload = {
                ...state.subscriptionPayload,
                ...action.payload,
            };
        },
        setReveneraId: (state, action: PayloadAction<string | null>) => {
            state.reveneraId = action.payload ?? '';
        },
    },
});

export const { setSubscriptionPayload, mergeSubscriptionPayload, setReveneraId } = subscriptionSlice.actions;
export const selectSubscritpionPayload = (state: RootState): SubscriptionPayload =>
    state.subscription.subscriptionPayload;
export const selectReveneraId = (state: RootState): string => state.subscription.reveneraId;

export default subscriptionSlice;
